export default __webpack_public_path__ + "static/media/resulted-in.ccee43b6.png";